import React from 'react';
import { X } from 'lucide-react';
import BillingSetup from './BillingSetup';
import { useAuth } from '../../state/AuthContext';
import './UpgradePage.css';

export default function UpgradePage({ message, onComplete, onDismiss }) {
  const { billingStatus, refreshBilling } = useAuth();

  const messageLimitReached = Boolean(
    billingStatus?.message_limit_reached ||
    message?.toLowerCase?.().includes('message limit')
  );
  const upgradeContext = messageLimitReached
    ? 'Keep your momentum going with more conversations and connected-account insights.'
    : 'Get more conversations, more connected accounts, and a clearer view of your money.';

  const handleComplete = async () => {
    await refreshBilling?.();
    await onComplete?.();
  };

  return (
    <div
      className={`upgrade-page${messageLimitReached ? ' message-limit-reached' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="upgrade-page-title"
    >
      <button
        type="button"
        className="upgrade-page-close"
        aria-label="Close upgrade page"
        onClick={onDismiss}
      >
        <X size={18} />
      </button>
      <div className="upgrade-page-body">
        <header className="upgrade-page-header">
          <div>
            <h1 id="upgrade-page-title">Upgrade</h1>
            <p>Choose a plan to get more from Wealth-Y.</p>
          </div>
        </header>

        <BillingSetup
          open
          mode="page"
          context="trial"
          message={upgradeContext}
          trialStatus={billingStatus}
          onComplete={handleComplete}
        />
      </div>
    </div>
  );
}
